// App.tsx
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import GlowAgainLanding from "./components/GlowAgainLanding";
import EarlyAccessPage from "./components/EarlyAccessPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<GlowAgainLanding />} />
        <Route path="/early-access" element={<EarlyAccessPage />} />
      </Routes>
    </Router>
  );
}

export default App;
